<div class="footer">
  <span data-smrtnc-test="footer--version">v{{ version }}</span>
  <a data-smrtnc-test="footer--licenses" target="_blank" rel="noopener noreferrer" [href]="licensesUrl">{{ 'COMMON.LICENSES' | translate }}</a>
  <a data-smrtnc-test="footer--data-privacy" target="_blank" rel="noopener noreferrer" [href]="dataprivacyUrl">{{ 'COMMON.DATA_PRIVACY' | translate }}</a>
  <a data-smrtnc-test="footer--imprint" target="_blank" rel="noopener noreferrer" [href]="imprintUrl">{{ 'COMMON.IMPRINT' | translate }}</a>
  <button
    *smaWebFeatureOn="LicenseFeatureFlag.VERSION_INTRO"
    type="button"
    class="fwe-btn fwe-btn-link fwe-dark"
    (click)="onVersionIntroClicked()"
    data-smrtnc-test="footer--release-info"
  >
    {{ 'COMMON.RELEASE_INFO' | translate }}
  </button>
</div>
